<template>
    <a-result status="warning" :title="title" :sub-title="comment">
        <template #extra>
            <slot>
                <a href="/"><a-button type="primary">返回首页</a-button></a>
            </slot>
        </template>
    </a-result>
</template>

<script>
export default {
    props: { 
        'title': { default: "404" },
        'comment': String, 
    }
}
</script>

<style scoped>
.ant-result >>> .ant-result-title {
    font-size: 48px;
}
.ant-result >>> .ant-result-subtitle {
    font-size: 18px;
}
</style>
